export const customScrollTo = (ref, options = {}) => {
  const modal = document.getElementById('modal');

  if (modal) {
    modal.scrollTo(0, ref.current.offsetTop);
  } else {
    ref.current.scrollIntoView({ block: 'center', ...options });
  }
};
